import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { SignInSuccess } from '../../store/actions';
import { map } from 'rxjs/operators';
import { selectAuthState } from '../../store/selectors';
@Injectable({
    providedIn: 'root',
})
export class SessionGuard implements CanActivate {
    constructor(private router: Router, private store: Store) {}
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.store.select(selectAuthState).pipe(
            map((authState) => {
                if (!authState.isLoggedIn) {
                    return true;
                }
                this.router.navigate(['/transactions']);
                return false;
            })
        );
    }
}
